import { clearUserInfo } from '@/utils'
import { getToken, fetchToken } from './token'
import { createLoading as createPageLoading  } from '@/pages/loading/utils/index'
/**
 * 权限校验相关的路由拦截器
 */
export async function initWorkWxRouterGuard(to, from, next) {
  console.log('守卫：work wx web', to.path)
  // 非白名单，没有token要获取token
  let removePageLoading = null
  if (!getToken()) {
    removePageLoading = createPageLoading()
    await fetchToken()
    clearUserInfo()
  }
  removePageLoading && removePageLoading()
}

